import type { FormLayout } from '../../../../../forms'
import { ElevatorTypeMap } from '../../elevator-type'
import type { ElevatorTypes } from '../../options'
import type { ElevatorSurveyPartialSchema } from '../form'
import { DirectHydraulicElevatorFormLayout } from './direct-hydraulic-elevator'
import { DumbwaiterFormLayout } from './dumbwaiter'
import { ElectricElevatorFormLayout } from './electric-elevator'
import { EscalatorFormLayout } from './escalator'
import { InclinedElevatorFormLayout } from './inclined-elevator'
import { LulaFormLayout } from './lula'
import { MaterialLiftFormLayout } from './material-lift'
import { MovingWalkFormLayout } from './moving-walk'
import { RackAndPinionFormLayout } from './rack-and-pinion'
import { RopedHydraulicElevatorFormLayout } from './roped-hydraulic-elevator'
import { VerticalReciprocatingConveyorFormLayout } from './vertical-reciprocating-conveyor'
import { WheelchairLiftFormLayout } from './wheelchair-lift'
import { WindTurbineFormLayout } from './wind-turbine'

const DEFAULT_LAYOUT = ElectricElevatorFormLayout

const LAYOUTS_BY_ELEVATOR_TYPE = {
  [ElevatorTypeMap.verticalReciprocatingConveyor]:
    VerticalReciprocatingConveyorFormLayout,
  [ElevatorTypeMap.directActingHydraulic]: DirectHydraulicElevatorFormLayout,
  [ElevatorTypeMap.ropedHydraulic]: RopedHydraulicElevatorFormLayout,
  [ElevatorTypeMap.dumbwaiter]: DumbwaiterFormLayout,
  [ElevatorTypeMap.electricGearred]: ElectricElevatorFormLayout,
  [ElevatorTypeMap.electricGearless]: ElectricElevatorFormLayout,
  [ElevatorTypeMap.escalator]: EscalatorFormLayout,
  [ElevatorTypeMap.inclinedElevatorLift]: InclinedElevatorFormLayout,
  [ElevatorTypeMap.lula]: LulaFormLayout,
  [ElevatorTypeMap.materialLift]: MaterialLiftFormLayout,
  [ElevatorTypeMap.movingWalk]: MovingWalkFormLayout,
  [ElevatorTypeMap.rackAndPinion]: RackAndPinionFormLayout,
  [ElevatorTypeMap.wheelchairLift]: WheelchairLiftFormLayout,
  [ElevatorTypeMap.windTurbine]: WindTurbineFormLayout,
} as const

/**
 * Gets the layout by elevator type. If the elevator type is not found, returns the Electric Elevator Form Layout.
 * This mirrors the behavior of the WEBNewSurvey script in FileMaker.
 *
 * @param elevatorType - The elevator type to get the layout for.
 * @returns The layout for the elevator type.
 */
export const getLayoutByElevatorType = (
  elevatorType: ElevatorTypes,
): FormLayout<typeof ElevatorSurveyPartialSchema> => {
  return elevatorType in LAYOUTS_BY_ELEVATOR_TYPE
    ? (LAYOUTS_BY_ELEVATOR_TYPE[
        elevatorType as keyof typeof LAYOUTS_BY_ELEVATOR_TYPE
      ] as FormLayout<typeof ElevatorSurveyPartialSchema>)
    : (DEFAULT_LAYOUT as FormLayout<typeof ElevatorSurveyPartialSchema>)
}
